module.exports = __webpack_public_path__ + "static/media/polytope_52_3_5_layers_5_5.07a8d70b.gif";